import React, { useState } from "react"
import { Button, Tooltip, CircularProgress } from "@material-ui/core"
import { useSnackbar } from "notistack"
import axiosInstance from "src/utils/axios"

const EXCEL_MIME =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

const getFilenameFromDisposition = (disposition, fallback) => {
  if (!disposition) return fallback
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i)
  if (utf8Match?.[1]) return decodeURIComponent(utf8Match[1])
  const asciiMatch = disposition.match(/filename="?([^"]+)"?/i)
  if (asciiMatch?.[1]) return asciiMatch[1]
  return fallback
}

const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

const ReportFaces = ({ conjunto }) => {
  const [exporting, setExporting] = useState(false)
  const { enqueueSnackbar } = useSnackbar()

  const exportData = async () => {
    if (!conjunto?.id || exporting) return

    setExporting(true)
    try {
      const response = await axiosInstance.get(
        `/api/biometrics/conjuntos/${conjunto.id}/rostros/export/`,
        { responseType: "blob" }
      )

      const contentType = response.headers["content-type"] || ""
      if (contentType.includes("application/json")) {
        const text = await response.data.text()
        const parsed = JSON.parse(text)
        throw new Error(parsed.error || parsed.message || "Error al exportar")
      }

      const blob = new Blob([response.data], {
        type: contentType || EXCEL_MIME,
      })
      const filename = getFilenameFromDisposition(
        response.headers["content-disposition"],
        `${conjunto.Nombre || "Conjunto"} Reporte de Rostros.xlsx`
      )

      downloadBlob(blob, filename)
      enqueueSnackbar("Reporte descargado", { variant: "success" })
    } catch (error) {
      let message = "Error al generar el reporte de rostros"
      const errorData = error.response?.data
      if (errorData instanceof Blob) {
        try {
          const parsed = JSON.parse(await errorData.text())
          message = parsed.error || parsed.message || message
        } catch {
          // keep default message
        }
      } else if (error.message && error.message !== "Network Error") {
        message = error.message
      } else if (errorData?.error || errorData?.message) {
        message = errorData.error || errorData.message
      }
      enqueueSnackbar(message, { variant: "error" })
    } finally {
      setExporting(false)
    }
  }

  return (
    <Tooltip title="Generar Reporte de Rostros">
      <span>
        <Button
          variant="outlined"
          color="primary"
          style={{ marginRight: 8 }}
          onClick={exportData}
          disabled={exporting || !conjunto?.id}
        >
          {exporting ? (
            <CircularProgress size={22} />
          ) : (
            <img
              alt="XLSX"
              style={{
                width: 22,
                height: 22,
              }}
              src="/assets/img/excel.png"
            />
          )}
        </Button>
      </span>
    </Tooltip>
  )
}

export default ReportFaces
